var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSwiperRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1485_8191)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0737 28.9884L30.9648 22.9231C30.8309 22.7891 30.6716 22.6826 30.496 22.61C30.3204 22.5374 30.1321 22.5 29.9419 22.5C29.7517 22.5 29.5634 22.5374 29.3878 22.61C29.2122 22.6826 29.0529 22.7891 28.919 22.9231C28.6506 23.1912 28.5 23.5537 28.5 23.9316C28.5 24.3095 28.6506 24.6721 28.919 24.9401L34.0193 30.004L28.919 35.0679C28.6506 35.3359 28.5 35.6985 28.5 36.0764C28.5 36.4543 28.6506 36.8168 28.919 37.0849C29.0536 37.2174 29.2132 37.3223 29.3888 37.3935C29.5643 37.4647 29.7523 37.5008 29.9419 37.4997C30.1315 37.5008 30.3195 37.4647 30.495 37.3935C30.6706 37.3223 30.8302 37.2174 30.9648 37.0849L37.0737 31.0196C37.2087 30.8867 37.3159 30.7284 37.389 30.5541C37.4622 30.3798 37.4998 30.1928 37.4998 30.004C37.4998 29.8152 37.4622 29.6282 37.389 29.4539C37.3159 29.2796 37.2087 29.1213 37.0737 28.9884Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1485_8191",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1485_8191"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1485_8191",
    result: "effect2_dropShadow_1485_8191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1485_8191",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwiperRight);
export default __webpack_public_path__ + "static/media/ArrowSwiperRight.2b5c1a92fb2aa59a433f424d19dd2f96.svg";
export { ForwardRef as ReactComponent };